/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(theme => ({
  listWrapperStyle: {
    display: 'flex'
  },
  searchFieldWrap: {
    borderBlockEnd: `1px solid ${theme.palette.divider}`,
  },
  listLeftPanel: {
    width: '40%',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`
  },
  listRightPanel: {
    width: '40%',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.divider}`,

  },
  centerBtnWrap: {
    width: '20%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    marginInline: Tokens.spacing['$sp-8-5'],
    '& button': {
      marginTop: Tokens.spacing['$sp-4'],
      marginBottom: Tokens.spacing['$sp-4'],
    }
  },
  listView: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    flexDirection: 'column',
    height: Tokens.spacing['$sp-100'],
  },
  noItemsFound: {
    marginTop: '50%',
    fontWeight: 500,
  },
  textField: {
    width: '90%',
    marginLeft: '2%',
  },
  selectedListItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: `${theme.palette.action.selected}`,
    '& .MuiListItemText-primary': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
    },
    '&:hover': {
      backgroundColor: `${theme.palette.action.selected}`,
    }
  },
  listItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiListItemText-primary': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
    },
    '&:hover': {
      backgroundColor: `${theme.palette.action.hover}`,
    }
  }
}));
